import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence React's `validateDOMNesting` warning for the specific
// pattern injected by the Emergent Visual Editor overlay
// (`<span data-ve-dynamic>` planted directly inside `<tbody>`).
// The runtime DOM is stripped by the editor before render — the
// warning is cosmetic. Filter only that one message so real
// nesting bugs still surface in the console.
if (typeof console !== "undefined" && console.error) {
  const _origError = console.error;
  console.error = (...args) => {
    const msg = args && args[0];
    if (typeof msg === "string" &&
        (msg.includes("validateDOMNesting") || msg.includes("cannot be a child of"))) {
      // Build resolved message by substituting %s tokens with subsequent args
      const rest = args.slice(1).map((a) => (a == null ? "" : String(a))).join(" ");
      const combined = msg + " " + rest;
      if (/span|data-ve-dynamic|tbody|tr/i.test(combined)) {
        return;
      }
    }
    _origError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
